import * as styles from './styles.css';
export { styles as gridStyles };
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { cx } from '@paypalcorp/pp-react-utils';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';

var _excluded$2 = ["as", "fluid", "form", "xxl", "className"];
var Container = function (_ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    _ref$fluid = _ref.fluid,
    fluid = _ref$fluid === void 0 ? false : _ref$fluid,
    _ref$form = _ref.form,
    form = _ref$form === void 0 ? false : _ref$form,
    _ref$xxl = _ref.xxl,
    xxl = _ref$xxl === void 0 ? false : _ref$xxl,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return /*#__PURE__*/React.createElement(as, _extends({
    className: cx(fluid && styles.containerFluid, form && styles.containerForm, xxl && styles.containerXxl, !fluid && !form && !xxl && styles.container, className),
    "data-ppui-info": "grid_4.1.0__8.9.0"
  }, props));
};

var _excluded$1 = ["as", "className", "form", "col"];
var Col = function (_ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    className = _ref.className,
    form = _ref.form,
    col = _ref.col,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var breakpointsMap = {
    xs: props.xs,
    sm: props.sm,
    md: props.md,
    lg: props.lg,
    xl: props.xl,
    xxl: props.xxl
  };
  return /*#__PURE__*/React.createElement(as, _extends({
    className: cx.apply(void 0, [styles.col, typeof col === 'number' && styles.cols[col], typeof col === 'boolean' && col && "".concat(styles.display.block, " ").concat(styles.cols.auto), typeof col === 'boolean' && !col && styles.display.none, _typeof(col) === 'object' && typeof col.span === 'number' && styles.cols[col.span], _typeof(col) === 'object' && col.order && styles.order[col.order], _typeof(col) === 'object' && col.display && styles.display[col.display], _typeof(col) === 'object' && col.offset && styles.offset[col.offset], form && styles.form[form]].concat(_toConsumableArray(Object.entries(breakpointsMap).map(function (mapItem) {
      var breakpoint = mapItem[0];
      var value = mapItem[1];
      if (typeof value === 'undefined') return '';
      if (value === 'auto') return styles.cols.auto;
      if (typeof value === 'boolean' && !value) return styles.display[breakpoint].none;
      if (typeof value === 'boolean' && value) return "".concat(styles.display[breakpoint].block, " ").concat(styles.cols[breakpoint][12]);
      if (typeof value === 'number') return styles.cols[breakpoint][value];
      if (_typeof(value) === 'object') {
        var classNames = [];
        var span = value.span,
          offset = value.offset,
          order = value.order,
          display = value.display;
        if (span && typeof span === 'number') classNames.push(styles.cols[breakpoint][span]);
        if (offset) classNames.push(styles.offset[breakpoint][offset]);
        if (order) classNames.push(styles.order[breakpoint][order]);
        if (display) classNames.push(styles.display[breakpoint][display]);
        return classNames.join(' ');
      }
      return '';
    })), [className]))
  }, props, {
    "data-ppui": "true"
  }));
};

var _excluded = ["as", "className", "noGutters", "row"];
var Row = function (_ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    className = _ref.className,
    _ref$noGutters = _ref.noGutters,
    noGutters = _ref$noGutters === void 0 ? false : _ref$noGutters,
    row = _ref.row,
    props = _objectWithoutProperties(_ref, _excluded);
  var breakpointsMap = {
    sm: props.sm || {},
    md: props.md || {},
    lg: props.lg || {},
    xl: props.xl || {},
    xxl: props.xxl || {}
  };
  return /*#__PURE__*/React.createElement(as, _extends({
    className: cx.apply(void 0, [styles.row, noGutters && styles.noGutters, _typeof(row) === 'object' && row.justifyContent && styles.justifyContent[row.justifyContent], _typeof(row) === 'object' && row.alignContent && styles.alignContent[row.alignContent], _typeof(row) === 'object' && row.alignSelf && styles.alignSelf[row.alignSelf], _typeof(row) === 'object' && row.alignItems && styles.alignItems[row.alignItems], _typeof(row) === 'object' && row.flex && styles.flex[row.flex]].concat(_toConsumableArray(Object.entries(breakpointsMap).map(function (mapItem) {
      var classNames = [];
      var breakpoint = mapItem[0];
      var _mapItem$ = mapItem[1],
        flex = _mapItem$.flex,
        justifyContent = _mapItem$.justifyContent,
        alignContent = _mapItem$.alignContent,
        alignItems = _mapItem$.alignItems,
        alignSelf = _mapItem$.alignSelf;
      if (justifyContent) classNames.push(styles.justifyContent[breakpoint][justifyContent]);
      if (alignContent) classNames.push(styles.alignContent[breakpoint][alignContent]);
      if (alignSelf) classNames.push(styles.alignSelf[breakpoint][alignSelf]);
      if (alignItems) classNames.push(styles.alignItems[breakpoint][alignItems]);
      if (flex) classNames.push(styles.flex[breakpoint][flex]);
      return classNames.join(' ');
    })), [className])),
    "data-ppui-info": "grid_4.1.0__8.9.0"
  }, props));
};

export { Col, Container, Row };
